import React, { useEffect, useState } from "react";
import { Alert, Row, Col, Form, Label, UncontrolledTooltip } from "reactstrap";

import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import classNames from "classnames";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import FormInput from "../../components/FormInput";

// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// hooks
import { useProfile, useRedux } from "../../hooks/index";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useSnackbar } from "../../utils/snackbar";

import topLogo from "../../assets/images/top-logo.webp";

import FormSelect from "../../components/FormSelect";
import { sendContact } from "../../api";
import LanguageSwitcher from "../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

const auth = getAuth();

interface LoginProps {}

type ContactFormTypes = {
  first_name: string;
  last_name: string;
  email: string;
  topic: string;
  message: string;
  is_accept_terms: boolean;
};

const ContactUs = () => {
  // global store
  const { useAppSelector } = useRedux();

  const { language } = useAppSelector(state => ({
    language: state.language.language,
  }));

  const { t, i18n } = useTranslation();

  const showSnackbar = useSnackbar();

  const navigate = useNavigate();
  const location = useLocation();
  const [redirectUrl, setRedirectUrl] = useState("/dashboard");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phone, setPhone] = useState("");
  const [selectboxFocused, setSelectboxFocused] = useState(false);

  const schema = yup.object().shape({
    email: yup
      .string()
      .email("This value should be a valid email.")
      .required("Please enter an email."),
    first_name: yup.string().required("Please enter first name"),
    last_name: yup.string().required("Please enter last name"),
    topic: yup.string().required("Please select topic"),
    message: yup.string().required("Please enter mesage"),
    is_accept_terms: yup
      .boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
  });

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm<ContactFormTypes>({
    resolver: yupResolver(schema),
    defaultValues: {
      is_accept_terms: false, // Important for checkbox
    },
  });

  const handleLogoClick = () => {
    navigate("/landing-page");
  };
  const onSubmitForm = async (values: ContactFormTypes) => {
    const payload = {
      ...values,
      phone_number: phone,
    };

    setIsSubmitting(true);
    try {
      const response: any = await sendContact(payload);
      if (response.success == false) {
        showSnackbar(response.message, "error");
        setIsSubmitting(false);
      } else {
        showSnackbar(response.message, "info");
        setIsSubmitting(false);
      }
    } catch (error: any) {
      showSnackbar(error.message, "error");
      setIsSubmitting(false);
    }
  };

  const { userProfile, loading } = useProfile();

  if (userProfile && !loading) {
    return <Navigate to={{ pathname: redirectUrl }} />;
  }

  return (
    <div className="contact-us">
      <div className=" flex-grow-1">
        <Navbar expand="lg" className="px-3 pt-3">
          <Container fluid>
            {/* Left: Logo */}
            <Navbar.Brand
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
            >
              <img
                src={topLogo}
                alt="Logo"
                width="160"
                height="40"
                className="d-inline-block align-center"
              />
            </Navbar.Brand>
            <span className="d-flex gap-3">
              <span className="d-block d-lg-none">
                <LanguageSwitcher />
              </span>
              <Navbar.Toggle
                aria-controls="offcanvasNavbar-expand"
                style={{ fontSize: "1rem", padding: "5px 7px" }}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar-expand"
                aria-labelledby="offcanvasNavbarLabel-expand"
                placement="end" // Right side
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                    {t("Menu")}
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ alignItems: "center" }}>
                  {/* Center-Right: Menu Items */}
                  <Nav className="ms-auto me-3">
                    <Button
                      className="rounded-pill py-1 d-none d-lg-block"
                      style={{
                        backgroundColor: "#ede7e7",
                        color: "gray",
                        borderColor: "#ede7e7",
                        paddingRight: "40px",
                        paddingLeft: "40px",
                      }}
                      onClick={() =>
                        window.open(
                          "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                          "_blank",
                        )
                      }
                    >
                      {t("Donate")}
                    </Button>
                    <Nav.Link as={Link} to="/about-us" className="contact-text">
                      {t("ABOUT US")}
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/learn-more"
                      className="contact-text"
                    >
                      {t("LEARN MORE")}
                    </Nav.Link>
                  </Nav>

                  {/* Right: Button */}

                  <Button
                    className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                        "_blank",
                      )
                    }
                  >
                    {t("Donate")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 d-none d-lg-block"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <span className="d-none d-lg-block">
                    <LanguageSwitcher />
                  </span>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </span>
          </Container>
        </Navbar>
        <div>
          <div className="w-full text-center">
            <h1 className="mt-8">{t("Contact and FeedBack")}</h1>
          </div>
          <div className="w-full d-flex justify-content-center">
            <Form
              className="contact-form"
              onSubmit={handleSubmit(onSubmitForm)}
            >
              <div className="contact-div">
                <Row className="g-4">
                  <Col lg={6}>
                    <FormInput
                      type="text"
                      name="first_name"
                      label={t("FIRST NAME*")}
                      labelClassName="form-label contact-text"
                      className="form-control"
                      register={register}
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col lg={6}>
                    <FormInput
                      type="text"
                      name="last_name"
                      label={t("LAST NAME*")}
                      labelClassName="form-label contact-text"
                      className="form-control"
                      register={register}
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>
                <Row className="mt-1 g-4">
                  <Col lg={6}>
                    <FormInput
                      type="text"
                      name="email"
                      label={t("E-MAIL-ADDRESS*")}
                      labelClassName="form-label contact-text"
                      className="form-control"
                      register={register}
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col lg={6}>
                    <label
                      className="contact-text"
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {t("Phone Number")}
                    </label>
                    <PhoneInput
                      country={"us"}
                      value={phone}
                      onChange={phone => setPhone(phone)}
                      inputStyle={{
                        width: "100%",
                        height: "38px",
                      }}
                    />
                  </Col>
                </Row>
                <Row className="contact-topic">
                  <Col lg={12}>
                    <FormSelect
                      name="topic"
                      label={t("CHOOSE YOUR TOPIC*")}
                      options={[
                        { value: "Report an Issue", label: "Report an Issue" },
                        { value: "Give a Feedback", label: "Give a Feedback" },
                        {
                          value: "Technical Question",
                          label: "Technical Question",
                        },
                        {
                          value: "Functional Question",
                          label: "Functional Question",
                        },
                        {
                          value: "Account Question",
                          label: "Account Question",
                        },
                        { value: "Wich a Feature", label: "Wich a Feacture" },
                        {
                          value: "Become a Partner / Investor",
                          label: "Become a Partner / Investor",
                        },
                        { value: "Other", label: "Other" },
                      ]}
                      register={register}
                      errors={errors}
                      isFocused={selectboxFocused}
                      onFocus={() => setSelectboxFocused(true)}
                      onBlur={() => setSelectboxFocused(false)}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 g-3 ">
                  <Col lg={12}>
                    <label
                      className="contact-text"
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {t("YOUR MESSAGE*")}
                    </label>
                    <textarea
                      {...(register ? register("message") : {})}
                      name="message"
                      id="message"
                      rows={4}
                      className={classNames("form-control", {
                        "is-invalid": errors && errors["message"],
                      })}
                      placeholder="Enter your message..."
                    />

                    {errors.message && (
                      <p className="text-danger">{errors.message.message}</p>
                    )}
                  </Col>
                </Row>
                <Row className="mt-3 g-3">
                  <Col lg={12}>
                    <div className="d-flex gap-2">
                      <input type="checkbox" {...register("is_accept_terms")} />
                      <span
                        className={
                          errors?.is_accept_terms
                            ? "text-danger"
                            : "contact-text"
                        }
                      >
                        {t(
                          "ACCEPT THE TERMS AND CONDITIONS AS WELL AS THE DATA POLICY",
                        )}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="d-flex justify-content-center mt-4">
                <Button
                  className="rounded-pill py-1"
                  onClick={handleSubmit(onSubmitForm)}
                  style={{
                    backgroundColor: "#1e587e",
                    borderColor: "white",
                    paddingRight: "50px",
                    paddingLeft: "50px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{t("SEND")}</span>
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <div className="footer mt-4">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default ContactUs;
